import React from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {useServices} from "../../hooks/use-services.hook";

const SkeletonsContainerBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: 200px;
`

export const FlightDatesSelectionSkeletonsComponent: React.FC = observer(() => {
    const services = useServices();
    return (
        <SkeletonsContainerBox>
            {services.language.translate('Loading...')}
        </SkeletonsContainerBox>
    )
});
